export default function fileToBase64(file) {
    return new Promise(res => {
        let newFile = file
        let reader = new FileReader()
        let base64 = ""
        reader.readAsDataURL(newFile)
        reader.onload = () => {
            base64 = reader.result
            res(base64)
        }
    })
}